import { useEffect } from 'react'
import {
  resetCrossClientLanding,
  selectCrossClientLandingSelectedOwnerId,
  setCrossClientLandingRunningExecutions,
  setCrossClientLandingRunningExecutionsLoading,
  setCrossClientLandingTeammates,
  setCrossClientLandingTeammatesLoading,
} from '../../../store/crossClient/crossClientLanding'
import { useLazyGetAllCrossClientQueryExecutionsQuery } from '../../../store/crossClient/crossClient'
import { useAppDispatch, useAppSelector } from '../../../store/hooks'
import { selectAccountId } from '../../../store/auth/authSlice'
import { useLazyGetAllUsersQuery } from '../../../store/user/user'

export const CrossClientLandingInitialization = () => {
  const dispatch = useAppDispatch()

  const accountId = useAppSelector(selectAccountId)
  const selectedOwnerId = useAppSelector(selectCrossClientLandingSelectedOwnerId)

  const [triggerGetAllCrossClientExecutions] = useLazyGetAllCrossClientQueryExecutionsQuery()
  const [triggerGetAllUsers] = useLazyGetAllUsersQuery()

  useEffect(() => {
    const getCrossClientLandingTeammates = async () => {
      try {
        const teammates = await triggerGetAllUsers({ accountId, identityTypes: ['idp'] }).unwrap()
        if (teammates?.data) {
          dispatch(setCrossClientLandingTeammates(teammates.data))
        }
      } finally {
        dispatch(setCrossClientLandingTeammatesLoading(false))
      }
    }
    getCrossClientLandingTeammates()
  }, [dispatch, accountId, triggerGetAllUsers])

  useEffect(() => {
    const getRunningExecutions = async () => {
      try {
        dispatch(setCrossClientLandingRunningExecutionsLoading(true))
        const executions = await triggerGetAllCrossClientExecutions({
          accountId,
          createdBy: selectedOwnerId ?? undefined,
          hasActiveEvaluations: true,
          expand: ['matches', 'progress', 'evaluationCounts'],
        }).unwrap()
        if (!executions.data.length) {
          return
        }
        dispatch(setCrossClientLandingRunningExecutions(executions.data))
      } catch (e) {
        console.error(e)
      } finally {
        dispatch(setCrossClientLandingRunningExecutionsLoading(false))
      }
    }
    getRunningExecutions()
  }, [dispatch, accountId, selectedOwnerId, triggerGetAllCrossClientExecutions])

  useEffect(() => {
    dispatch(resetCrossClientLanding())
  }, [dispatch])

  return null
}
